export default __webpack_public_path__ + "static/media/foodbank_1.074af898.png";